import { FecAccountMappingFilter } from '../enums/fecAccountMappingFilter'
import { FecAccountMappingStatus } from '../enums/fecAccountMappingStatus'
import type { FecAccountMapping } from '../types/fecAccountMapping'

interface FilterFecAccountMappingsParams {
  accountMappings: FecAccountMapping[]
  filter: FecAccountMappingFilter
  searchQuery: string
}

export const filterFecAccountMappings = ({
  accountMappings,
  filter,
  searchQuery,
}: FilterFecAccountMappingsParams): FecAccountMapping[] => {
  const normalizedQuery = searchQuery.trim().toLowerCase()

  return accountMappings.filter((mapping) => {
    if (filter === FecAccountMappingFilter.New && mapping.status !== FecAccountMappingStatus.New) {
      return false
    }

    if (!normalizedQuery) {
      return true
    }

    return (
      mapping.accountNo.toLowerCase().includes(normalizedQuery) || mapping.label.toLowerCase().includes(normalizedQuery)
    )
  })
}
